function getDomain (path) {
  /**
   * Returns the base domain of the site, such as
   * https://sammies.com
   * or
   * http://example.com:8000
   */
  let domain = window.location.protocol + '//' + window.location.hostname
  if (window.location.port) {
    domain += ':' + window.location.port
  }
  if (path) {
    domain += path
  }
  return domain
}

function facebookShareLink (path) {
  return 'http://www.facebook.com/sharer/sharer.php?u=' + getDomain(path)
}

function twitterShareLink (text, path) {
  let string = 'http://twitter.com/intent/tweet?text='

  if (text) {
    string += text
  }
  if (path) {
    string += ' ' + getDomain(path)
  }
  return string
}

export {getDomain, facebookShareLink, twitterShareLink}



// WEBPACK FOOTER //
// ./src/utils/share.js